(() => {
  /* BEZELOR policy popups: puts the short branded summaries (snippets/bezelor-policy-popups.liquid)
     into the existing Shipping / Returns / Security popups. Opening and closing still work the
     same way (bezelor-pdp-extras.js). */
  const apply = () => {
    document.querySelectorAll('dialog.bz-policy-dialog[data-bz-policy]:not(.bz-pp)').forEach((dialog) => {
      const template = document.getElementById('BzPP-' + dialog.dataset.bzPolicy);
      if (!template) return;
      const content = template.content.cloneNode(true);
      const title = content.querySelector('[data-bz-pp-title]');
      if (title) {
        title.id = dialog.id + '-title';
        dialog.setAttribute('aria-labelledby', title.id);
      }
      const full = content.querySelector('[data-bz-pp-full]');
      if (full) full.href = dialog.dataset.policyUrl || '/policies/' + dialog.dataset.bzPolicy + '-policy';
      const scroll = document.createElement('div');
      scroll.className = 'bz-pp__scroll';
      const foot = content.querySelector('.bz-pp__foot');
      if (foot) foot.remove();
      scroll.append(content);
      dialog.replaceChildren(scroll);
      if (foot) dialog.append(foot);
      dialog.classList.add('bz-pp');
      /* Always open at the top */
      new MutationObserver(() => {
        if (dialog.open) scroll.scrollTop = 0;
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', () => setTimeout(apply, 0));
  document.addEventListener('product-info:loaded', () => setTimeout(apply, 0));
})();
